<template>
  <div class="echo-ios-privacy_protocol">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
      </van-nav-bar>
    </div>
    <div class="page-container">
      <iframe class="iframe" src="/iframe/kiko/PrivacyPolicy.html" frameborder="0" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38
    }
  }
}
</script>

<style lang="scss" scoped>
.echo-ios-privacy_protocol {
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  .page-container {
    box-sizing: border-box;
    background-color: #ffffff;
    padding: 0 15px;
    flex: 1;

    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
